import { Hero } from "@/components/triarch/Hero";
import { SignalCards } from "@/components/triarch/SignalCards";
import { FinalCTA } from "@/components/triarch/FinalCTA";

export default function HomePage() {
  return (
    <>
      <Hero />
      <SignalCards />
      <FinalCTA />
    </>
  );
}
